import React, { FunctionComponent } from "react";
import headerBarStyles from "./headerBarStyle";

export const HeaderBarSpacer: FunctionComponent = () => {
  const classes = headerBarStyles();

  return <div className={classes.appBarSpacer} />;
};
